import React from "react";
import { FiltersBar, FiltersBarLabels } from "@/features/orders-analytics/components/FiltersBar";
import { useAvailableClients } from "@/features/orders-analytics/hooks/use-available-clients";
import type { OrdersAnalyticsFilters } from "@/features/orders-analytics/types/orders-analytics.types";

type Props = {
    /** What the server answered for; `null` where the filters already say it (D129). */
    chips: { scope: string; window: string } | null;
    filters: OrdersAnalyticsFilters;
    onFiltersChange: (next: OrdersAnalyticsFilters) => void;
    busy: boolean;
    onRefresh: () => void;
    labels?: FiltersBarLabels;
};

/**
 * D105: the same workspace + range + refresh bar every other dashboard of the app
 * uses — the component itself, fed through Daily's adapter and the same client list
 * source (`useAvailableClients`). The chips beside it say what the server answered
 * for: the workspace and the window of the evidence on screen.
 */
export const DailyHeaderMeta: React.FC<Props> = ({ chips, filters, onFiltersChange, busy, onRefresh, labels }) => {
    const { availableClients } = useAvailableClients(filters);
    return (
        <div className="daily-header-meta">
            {chips === null ? null : (
                <div className="daily-chips" aria-label="Alcance y ventana de la evidencia">
                    <span className="daily-chip">{chips.scope}</span>
                    <span className="daily-chip">{chips.window}</span>
                </div>
            )}
            <FiltersBar
                filters={filters}
                availableClients={availableClients}
                onFiltersChange={onFiltersChange}
                onRefresh={onRefresh}
                loading={busy}
                labels={labels}
            />
        </div>
    );
};
